export default __webpack_public_path__ + "static/media/soc2.cc9fc1f8.svg";